module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-data"
  }, [_vm._v("\n    Vi fandt desværre ingen data her.\n    "), _c('br'), _vm._v("\n    Hvis du mener dette er en fejl, så "), _c('a', {
    attrs: {
      "href": "mailto:troels@proebitda.dk"
    }
  }, [_vm._v("kontakt os")]), _vm._v(" venligst.\n")])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-23bfba74", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23bfba74"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/NoData.vue
// module id = 799
// module chunks = 0